export default __webpack_public_path__ + "static/media/announcements.daf094b9.svg";